import type { ReactNode } from "react";

import type { WPVideoElement } from "../../../../models/WPContentBlock";

export async function fetchVideoElement(
  model: WPVideoElement,
): Promise<ReactNode> {
  const { VideoElement } = await import(
    "../../../components/blocks/VideoElement/VideoElement"
  );

  return <VideoElement model={model} />;
}
